type NumberFormatterProps = {
  number: number;
  decimals?: number;
};

export const NumberFormatter = (props: NumberFormatterProps) => {
  const { number, decimals = 2 } = props;
  const numberToFixed = number < 0 || Number.isNaN(number) || number === undefined ? '0' : Number(number).toFixed(decimals);

  // Separera hela delen och decimaldelen
  const [integerPart, decimalPart] = numberToFixed.split('.');

  // Lägg till tusentalsavgränsare till den hela delen och hantera eventuell omtilldelning
  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return (
    <>
      {formattedIntegerPart},{decimalPart || '00'}{' '}
    </>
  );
};
